import React, { useState } from "react";




const StockDetails = ({details, todayLTP}) =>{
  // console.log(details)      
        
        
        let rank = 0;
        let MarketCap = parseInt(details?.MARKETCAP);
        let Volume = parseInt(details?.ttl_trd_qty);
        let Prev_Volume = parseInt(details?.prev_volume || 0);

        
        let LTP =parseFloat(details?.close_price);
        let Turnover =  (Volume * LTP)/10000000 // parseFloat(details?.trunover_lacs); // Volume * LTP;
        let Turnover_per =  parseFloat(((Turnover/MarketCap) * 100).toFixed(2));

        let RSI = parseFloat(details?.RSI || 0);
        let ADX = parseFloat(details?.ADX || 0);
        let ATR_PER = parseFloat(details?.ATR_PER || 0);
        let SMA20 = parseFloat(details?.DMA20  || 0);
        let SMA50 = parseFloat(details?.DMA50  || 0);
        let SMA200 = parseFloat(details?.DMA200  || 0);
        let angle_5 = parseFloat(details?.angle5  || 0);
        let angle_10 = parseFloat(details?.angle10  || 0);
        let angle_15 = parseFloat(details?.angle15  || 0);
        let angle_20 = parseFloat(details?.angle20  || 0);
        let AverageVol = parseInt(details?.avgVolume  || 0);
        let trueAvgVolume = Number(details?.trueAvgVolume) === 1;
        let TodayIncVol = Prev_Volume !== 0 ? parseFloat(((Volume - Prev_Volume) * 100) / Prev_Volume).toFixed(2) : 0;
        let Delivery_per = parseFloat(details?.delivery_per || 0);
        let Prev_delivery_per = parseFloat(details?.prev_delivery_per || 0);
        let IncreaseDel = (Delivery_per - Prev_delivery_per).toFixed(2);
        let Down_52 = ((details?.high52w - LTP)*100/details?.high52w).toFixed(2);
        let spikes = Number(details?.SMEntery) === 1;
        let volume_spike = Number(details?.volume_spike) === 1;
        let structureData = JSON.parse(details?.structure_json || '[]');
        let structure = details?.structure || '';
        let EMA_Angle = parseFloat(details?.EMA_Angle);
        let delivery_date = details?.delivery_date
        

        // Rank 1 : Structure
        if (["UPTREND", "BULLISH_CHOCH", "EARLY_UPTREND"].includes(structure)) {
            rank += 1;
        }

        // Rank 2 : Momentum
        if(EMA_Angle > 25){
            rank += 1;
        }

        // Rank 3 : RSI
        if(RSI > 35 && RSI < 85){
            rank += 1;
        }

        // Rank 4 : ADx
        if(ADX > 30 && ADX < 85){
            rank += 1;
        }

        // Rank 5 : If ATR_PER > ADTR, volatility is increasing → Expect big price movements
        if(ATR_PER > 5){
            rank += 1;
        }  

        // Rank 6 : LTP > SMA20
        if(LTP > SMA20){
            rank += 1;
        }  

        // Rank 7 : SMA20 > SMA50
        if(SMA20 > SMA50){
            rank += 1;
        }  

        // Rank 8 : SMA50 > SMA200
        if(SMA50 > SMA200){
            rank += 1;
        }    

        // Rank 9 : volume_spike
        if(spikes === true){
            rank += 1;
        } 

        if(volume_spike === true){
            rank += 1;
        } 

        // Rank 10 : Angle 5
        if(angle_5 > 25){
            rank += 1;
        } 

        // Rank 11 : Angle 10
        if(angle_10 > 20){
            rank += 1;
        } 
        
        // Rank 12 : Angle 15
        if(angle_15 > 15){
            rank += 1;
        }  
        
        // Rank 13 : Angle 20
        // if(angle_20 > 10){
        //     rank += 1;
        // }    

        // Rank 13 : Volume
        if(Volume > 200000 && trueAvgVolume === true){
            rank += 1;
        }   

        // Rank 14 : AverageVol
        if(Volume > AverageVol){
            rank += 1;
        } 

        // Rank 15 : TodayIncVol
        if(TodayIncVol > 25){
            rank += 1;
        } 

        // Rank 16 : Delivery_per %
        if(Delivery_per >= 50){
            rank += 1;
        }   

        // Rank 17 : IncreaseDel
        if(IncreaseDel > 10){
            rank += 1;
        } 

        // Rank 18 : Down_52
        if(Down_52 >= 8 && Down_52 <= 30){
            rank += 1;
        } 
        
        // Rank 19 : MarketCap
        if(MarketCap >= 1000){
            rank += 1;
        } 

        // Rank 20 : Turnover
        if(Turnover_per >= 5){
            rank += 1;
        }
        

        
        const strength = {
            // 'strength'          : rank,
            'structure'         : structure,
            'EMA_Angle'         : EMA_Angle,
            'RSI'               : RSI,
            'ADX'               : ADX,
            'ATR_PER'           : ATR_PER,
            'SMA20'             : SMA20,
            'SMA50'             : SMA50,
            'SMA200'            : SMA200,
            'angle_5'           : angle_5,
            'angle_10'          : angle_10,
            'angle_15'          : angle_15,
            'spikes'            : spikes,
            'volume_spike'      : volume_spike,
            'Volume'            : Volume,
            'AverageVol'        : AverageVol,
            'trueAvgVolume'     : trueAvgVolume,
            'TodayIncVol'       : TodayIncVol,
            'Delivery_per'      : Delivery_per,
            'IncreaseDel'       : IncreaseDel,
            'Down_52'           : Down_52,
            'MarketCap'         : MarketCap,
            'Turnover_per'      : Turnover_per
        };



        
        const green = "#02b319";
        const red = "#e70000";

    
    return(
        <React.Fragment>
              <ul>
                <li key={31} style={{fontSize:'13px'}} id="stockDetail_1">[<strong className="strength_count">{rank}/{Object.keys(strength).length}</strong>] | {`S: ${structureData.slope} | C: ${structureData.confidence}`}</li>
                <li key={1}><span>Structure</span><span style={{fontSize: '12px', color:(strength.structure === "BULLISH_CHOCH" || strength.structure === "BULLISH" || strength.structure === "UPTREND")? green:red }}>{strength.structure}</span></li>
                <li key={2}><span>Momentum</span><span style={{color:(strength.EMA_Angle > 50)? green:red }}>{strength.EMA_Angle}</span></li>
                <li key={3}><span>RSI</span><span style={{color:(strength.RSI > 35 && strength.RSI < 80)? green:red }}>{strength.RSI}</span></li>
                <li key={4}><span>ADX</span><span style={{color:(strength.ADX > 30 && strength.ADX < 80)? green:red }}>{strength.ADX}</span></li>
                <li key={5}><span>ATR_PER</span><span style={{color: strength.ATR_PER > 5 ? green:red }}>{strength.ATR_PER}</span></li>
                <li key={6}><span>SMA20</span><span style={{color:(LTP > strength.SMA20)? green:red }}>{strength.SMA20}</span></li>
                <li key={7}><span>SMA50</span><span style={{color:(strength.SMA20 > strength.SMA50)? green:red }}>{strength.SMA50}</span></li>
                <li key={8}><span>SMA200</span><span style={{color:(strength.SMA50 > strength.SMA200)? green:red }}>{strength.SMA200}</span></li>
                <li key={9}><span>Deg 5days</span><span style={{color:(strength.angle_5 > 25)? green:red }}>{strength.angle_5}°</span></li>
                <li key={10}><span>Deg 10days</span><span style={{color:(strength.angle_10 > 20)? green:red }}>{strength.angle_10}°</span></li>
                <li key={11}><span>Deg 15days</span><span style={{color:(strength.angle_15 > 15)? green:red }}>{strength.angle_15}°</span></li>
                
                {/* <li key={12}><span>Deg 5° &gt; 9° &gt; 14°</span> <span style={{color:(strength.angle_5 > strength.angle_9 && strength.angle_9 > strength.angle_14)? green:red }}>{strength.angle_5}° | {strength.angle_9}° |  {strength.angle_14}°</span></li> */}

                <li key={13}><span>Spikes</span><span style={{color:(strength.spikes === true)? green:red }}>{strength.spikes === true? 'Yes':'No'}</span></li>
                <li key={14}><span>Volume Spike</span><span style={{color:(strength.volume_spike === true)? green:red }}>{strength.volume_spike === true? 'Yes':'No'}</span></li>
                <li key={15}><span>Volume</span><span style={{color:(strength.trueAvgVolume === true)? green:red }}>{strength.Volume.toLocaleString('en-IN')}</span></li>
                <li key={16}><span>Average Vol</span><span style={{color:(strength.Volume >= strength.AverageVol  && strength.trueAvgVolume === true)? green:red }}>{strength.AverageVol.toLocaleString('en-IN')}</span></li>
                <li key={17}><span>Vol Inc Per</span><span style={{color:(strength.TodayIncVol >= 25)? green:red }}>{strength.TodayIncVol}%</span></li>
                <li key={18}><span>Delivery Per</span><span style={{color:(strength.Delivery_per >= 50)? green:red }}>{strength.Delivery_per}%</span></li>
                <li key={19}><span>Del Inc Per</span><span style={{color:(strength.IncreaseDel >= 5)? green:red }}>{strength.IncreaseDel}%</span></li>
                <li key={20}><span>Down_52</span><span style={{color:(strength.Down_52 >= 8 && strength.Down_52 <= 30)? green:red }}>{strength.Down_52}%</span></li>
                <li key={21}><span>MarketCap</span><span style={{color:(strength.MarketCap >= 1000)? green:red }}>{parseInt(strength.MarketCap).toLocaleString('en-IN')}</span></li>
                <li key={22}><span>Turnover</span><span style={{color:(strength.Turnover_per > 5)? green:red }}>{Turnover.toFixed(2)} [{strength.Turnover_per}%]</span></li>
              </ul>
    </React.Fragment>
    )

}
export default StockDetails;